const $ = jQuery;

let updateStickyPosition = (Item)=>{
	let parent = $(Item).parent();
	let bbox = parent[0].getBoundingClientRect();
	if (bbox.top < 0 && bbox.top+bbox.height> $(window).height()){
		$(Item).css({
			position: 'fixed',
			top: 0,
			bottom: 'auto'
		})
	}
	else if (bbox.top > 0){
		$(Item).css({
			position: 'absolute',
			top: 0,
			bottom: 'auto',
		})		
	}
	else if (bbox.top + bbox.height < $(window).height() ){
	$(Item).css({
			position: 'absolute',
			top: 'auto',
			bottom: 0,
		})	
	}
}


let updateStickyPositions = ()=>{
	$('.js-sticky-top').each(function(){
		updateStickyPosition(this);
	});
}


$(document).ready(updateStickyPositions);
$(window).scroll(updateStickyPositions)
$(window).resize(updateStickyPositions)

window.updateParallax = updateStickyPositions;